import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { CheckOutlined, CloseOutlined, InfoCircleTwoTone, SaveTwoTone } from '@ant-design/icons';
import {
  Switch,
  Row,
  Col,
  Typography,
  Select,
  DatePicker,
  Space,
  Segmented,
  Input,
  Popover,
  Button,
  Modal,
} from 'antd';

import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin,
} from '../../config/api-connect';

import './style.css';
import { postData, getData } from '../../config/api-connect';

const { Text, Link } = Typography;
const { Option } = Select;
const { TextArea } = Input;

const successModal = (message) => {
  Modal.success({
    title: message,
  });
};

const errorModal = (message) => {
  Modal.error({
    title: message,
  });
};

export default function AddExpense() {
  const [isCentralExpense, setIsCentralExpense] = useState(false);
  const [yearMonth, setYearMonth] = useState();
  const [expenseType, setExpenseType] = useState('Coach Expense');
  const [amount, setAmount] = useState();
  const [receivedVenues, setReceivedVenues] = useState([]);
  const [selectedVenueId, setSelectedVenueId] = useState('');
  const [selectedBuddyId, setSelectedBuddyId] = useState('');
  const [expenseTitle, setExpenseTitle] = useState('');
  const [file, setFile] = useState([]);
  const [remarks, setRemarks] = useState('');

  useEffect(() => {
    getDetailsForExpenseAdding();
  }, []);

  const onChangeCentralExpenseCheck = (checked) => {
    setIsCentralExpense(checked);
    setSelectedVenueId('');
    setSelectedBuddyId('');
    if (isCentralExpense == true) {
      setExpenseType('Central Expense');
    } else {
      setExpenseType('Coach Expense');
    }
  };

  const onChangeYearMonth = (date, dateString) => {
    setYearMonth(dateString);
  };

  const onChangeAmount = (e) => {
    setAmount(e.target.value);
  };

  const onChangeExpenseTitle = (e) => {
    setExpenseTitle(e.target.value);
  };

  const onChangeFile = (e) => {
    setFile(e.target.files[0]);
  };

  const onChangeRemarks = (e) => {
    setRemarks(e.target.value);
  };

  const getDetailsForExpenseAdding = async () => {
    await getData('/finance/get_details_for_add_expense/')
      .then((response) => {
        setReceivedVenues(response.result);
      })
      .catch((error) => {
        errorModal(error.message);
      });
  };

  const saveExpense = () => {
    var expense_type = 2;

    if (isCentralExpense) {
      expense_type = 1;
    }

    const url = `${getLocationOrigin()}/finance/create_expense/`;
    const options = { ...defaultOptions };

    const expenseData = new FormData();
    expenseData.append('file', file);
    expenseData.append('venue_id', selectedVenueId);
    expenseData.append('year_and_month', yearMonth);
    expenseData.append('amount', amount);
    expenseData.append('buddy_id', selectedBuddyId);
    expenseData.append('expense_title', expenseTitle);
    expenseData.append('remarks', remarks);
    expenseData.append('expense_type', expense_type);

    options['method'] = 'POST';
    options['body'] = expenseData;
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then((data) => {
        successModal(data.result);
      })
      .catch((error) => {
        errorModal(error.message);
      });
  };

  return (
    <div className="expense-main-container">
      <span></span>

      <div className="expense-center-container">
        <div className="expense-header">Add New Expense</div>

        <div className="expense-body">
          <Row>
            <Col span={8}>
              <Text type="primary"> Is Central Expense </Text>
            </Col>
            <Col span={8}>
              <Switch
                checkedChildren="yes"
                unCheckedChildren="no"
                onChange={onChangeCentralExpenseCheck}
              />
            </Col>
          </Row>

          {!isCentralExpense && (
            <Row className="expense-row">
              <Col span={8}>
                <Text type="primary"> Choose Venue </Text>
              </Col>
              <Col span={8}>
                <Select
                  allowClear
                  showSearch
                  className="expense-select"
                  optionFilterProp="children"
                  placeholder="start typing..."
                  onChange={(input, option) => setSelectedVenueId(option.value)}
                  value={selectedVenueId}
                  filterOption={(input, option) => option.children.includes(input)}
                  filterSort={(optionA, optionB) =>
                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                  }
                >
                  {receivedVenues.map((item, index) => (
                    <Option value={item.id} key={index}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Col>
            </Row>
          )}

          <Row className="expense-row">
            <Col span={8}>
              <Text type="primary"> Year & Month</Text>
            </Col>
            <Col span={8}>
              <DatePicker
                defaultValue={yearMonth}
                onChange={onChangeYearMonth}
                picker="month"
                className="expense-select"
              />
            </Col>
          </Row>

          <Row className="expense-row">
            <Col span={8}>
              <Text type="primary"> Amount </Text>
            </Col>
            <Col span={8}>
              <Input
                placeholder=""
                className="expense-select"
                onChange={onChangeAmount}
                value={amount}
              />
            </Col>
          </Row>

          {!isCentralExpense && (
            <Row className="expense-row">
              <Col span={8}>
                <Text type="primary"> Buddy </Text>
                <Popover content="Buddy who is responsible for this expense">
                  <InfoCircleTwoTone className="expense-info-icon" />
                </Popover>
              </Col>
              <Col span={14}>
                <Select
                  allowClear
                  showSearch
                  className="expense-select"
                  optionFilterProp="children"
                  placeholder="start typing buddy name..."
                  onChange={(input, option) => setSelectedBuddyId(option.value)}
                  value={selectedBuddyId}
                  filterOption={(input, option) => option.children.includes(input)}
                  filterSort={(optionA, optionB) =>
                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                  }
                >
                  {receivedVenues.map(
                    (item) =>
                      item.id == selectedVenueId &&
                      item.tagged_buddies.map((buddy, index) => (
                        <Option value={buddy.id} key={index}>
                          {buddy.name}
                        </Option>
                      )),
                  )}
                </Select>
              </Col>
            </Row>
          )}

          <Row className="expense-row">
            <Col span={8}>
              <Text type="primary"> Expense Title </Text>
              <Popover content="Specify what the expense is">
                <InfoCircleTwoTone className="expense-info-icon" />
              </Popover>
            </Col>
            <Col span={8}>
              <Input
                placeholder=""
                className="expense-select"
                onChange={onChangeExpenseTitle}
                value={expenseTitle}
              />
            </Col>
          </Row>

          <Row className="expense-row">
            <Col span={8}>
              <Text type="primary"> Document/Bill </Text>
              <Popover content="Relevant document/bill about this expense">
                <InfoCircleTwoTone className="expense-info-icon" />
              </Popover>
            </Col>
            <Col span={8}>
              <input type="file" onChange={onChangeFile} />
            </Col>
          </Row>

          <Row className="expense-row">
            <Col span={8}>
              <Text type="primary"> Remarks (if any) </Text>
            </Col>
            <Col span={8}>
              <TextArea
                rows={4}
                value={remarks}
                onChange={onChangeRemarks}
                showCount
                maxLength={100}
                placeholder="type here..."
                className="expense-select"
              />
            </Col>
          </Row>

          <Row className="expense-button-row">
            <Button
              onClick={() => saveExpense()}
              type="primary"
              shape="round"
              icon={<SaveTwoTone />}
              className="expense-btn-wide"
            >
              {' '}
              Save{' '}
            </Button>
          </Row>
        </div>
      </div>

      <span></span>
    </div>
  );
}
